import { Component, OnInit } from '@angular/core';
import { Retailer } from './retailer';
import { AppService } from '../app.service';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-retailer',
  templateUrl: './retailer.component.html',
  styleUrls: ['./retailer.component.css']
})

export class RetailerComponent implements OnInit {

  constructor(private service:AppService) { }

  ngOnInit() {
  }


loader:boolean=false;
  retailer=new Retailer();
  errorMsg:string;
  successMsg:string;
  
	submitRetailer(){

    var chkLogin=this.service.isLoggedIn();

    if(chkLogin){
      const userData=JSON.parse(localStorage.getItem('currentUser'));
    this.loader=true;
      this.service.post('/addRetailer',{name:this.retailer.name,amount:this.retailer.amount,password:this.retailer.password,key:userData.auth_token}).subscribe(
        data=>{ 
            this.loader=false;
            alert(data[0].msg);
            if(data[0].error=='0')
            { 
              location.reload();
            }
           
        },
        error=>{
            // this.errorMsg=error.errorDesc;
            alert(error.errorDesc);
            this.loader=false;
        }
      );
    }else{
      alert("Please first login.");
    }
  }


  
  submitRetailerEnd(){

    var chkLogin=this.service.isLoggedIn()
    if(chkLogin){
      const userData=JSON.parse(localStorage.getItem('currentUser'));
    this.loader=true;
      this.service.post('/fundTransfer',{amount:this.retailer.fund_amount,mobile:this.retailer.fund_mobile,key:userData.auth_token}).subscribe(
        data=>{ 
            this.loader=false;
            alert(data[0].msg);
            if(data[0].error=='0')
            { 
              location.reload();
            }
           
        },
        error=>{
            // this.errorMsg=error.errorDesc;
            alert(error.errorDesc);
            this.loader=false;
        }
      );
    }else{
      alert("Please first login.");
    }
  }


  numberOnly(event, length = 0): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } else if (length > 0) {
      var valueLength = (event.target.value).length;
      if (valueLength >= length) {
        return false;
      }
    } else {
      return true;
    }
  }
}
